import { MY_LOCATION_FETCH_REQUEST, MY_LOCATION_FETCH_SUCCESS, MY_LOCATION_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    mylocations: [],
    error: ''
}

const mylocations = (state = initialState, action) => {
    switch (action.type) {
        case MY_LOCATION_FETCH_REQUEST:
            return {
                loading: true,
                mylocations: [],
                error: '',
            }
        case MY_LOCATION_FETCH_SUCCESS:
            return {
                loading: false,
                mylocations: action.payload,
                error: ''
            }
        case MY_LOCATION_FETCH_FAILURE:
            return {
                loading: false,
                mylocations: [],
                error: action.payload
            }
        default:
            return state
    }
}

export default mylocations;